// Configuración centralizada de APIs
// Este archivo maneja todas las URLs de las APIs basándose en las variables de entorno

const API_CONFIG = {
  // API Blog - Puerto 8000 en desarrollo
  BLOG: process.env.REACT_APP_BLOG_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
  
  // API Ideas - Puerto 8001 en desarrollo
  IDEAS: process.env.REACT_APP_IDEAS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001',
  
  // API Projects - Puerto 8002 en desarrollo
  PROJECTS: process.env.REACT_APP_PROJECTS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002',
  
  // API Publications - Puerto 8003 en desarrollo
  PUBLICATIONS: process.env.REACT_APP_PUBLICATIONS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8003',
  
  // API Interactions - Puerto 8004 en desarrollo
  INTERACTIONS: process.env.REACT_APP_INTERACTIONS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8004',
  
  // API Profile - Puerto 8005 en desarrollo
  PROFILE: process.env.REACT_APP_PROFILE_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8005',
  
  // API Arnold - Puerto 8006 en desarrollo
  ARNOLD: process.env.REACT_APP_ARNOLD_API_URL || process.env.REACT_APP_BACKEND_URL || 'https://n8n.basecomputing.com.co'
};

// Función helper para obtener la URL base de una API específica
export const getApiUrl = (apiName) => {
  return API_CONFIG[apiName.toUpperCase()];
};

// Función helper para construir URLs completas de endpoints
export const buildApiUrl = (apiName, endpoint) => {
  const baseUrl = getApiUrl(apiName);
  return `${baseUrl}${endpoint}`;
};

// URLs predefinidas para endpoints comunes
export const API_ENDPOINTS = {
  // Blog endpoints
  BLOG_POSTS: () => buildApiUrl('BLOG', '/api/v1/blog/'),
  BLOG_POST: (id) => buildApiUrl('BLOG', `/api/v1/blog/${id}/`),
  
  // Ideas endpoints
  IDEAS_LIST: () => buildApiUrl('IDEAS', '/api/v1/ideas/'),
  
  // Projects endpoints
  PROJECTS_LIST: () => buildApiUrl('PROJECTS', '/api/v1/projects/'),
  
  // Publications endpoints
  PUBLICATIONS_LIST: () => buildApiUrl('PUBLICATIONS', '/api/v1/publications/'),
  
  // Interactions endpoints
  POST_VIEW: (id) => buildApiUrl('INTERACTIONS', `/api/v1/interactions/objects/posts/${id}/view`),
  POST_LIKE: (id) => buildApiUrl('INTERACTIONS', `/api/v1/interactions/objects/posts/${id}/like`),
  POST_COMMENTS: (id) => buildApiUrl('INTERACTIONS', `/api/v1/interactions/objects/posts/${id}/comments/`),
  COMMENT_LIKE: (id) => buildApiUrl('INTERACTIONS', `/api/v1/interactions/comments/${id}/like/`),
  PROFILE_IMAGE_VIEW: (type) => buildApiUrl('INTERACTIONS', `/api/v1/interactions/profile_images/${type}/view/`),
  
  // Profile endpoints
  PROFILE_DATA: () => buildApiUrl('PROFILE', '/api/v1/profile/profile/'),
  
  // Arnold endpoints
  ARNOLD_CHAT: () => buildApiUrl('ARNOLD', '/webhook/arnold/chat/'),
  ARNOLD_AUDIO: () => buildApiUrl('ARNOLD', '/webhook/arnold/audio/')
};

export default API_CONFIG;
